export const FakeData = {
	menu: [
		{
			title: "Bảng điều khiển",
			url: "/",
			icon: "far fa-home",
		},
		{
			title: "Phòng ban",
			url: "/Department",
			icon: "fa-light fa-chart-tree-map",
		},
		{
			title: "Chức vụ",
			url: "/Position",
			icon: "fa-light fa-chart-pyramid",
		},
		{
			title: "Nhân viên",
			icon: "fa-light fa-users",
			children: [
				{
					title: "Danh sách nhân viên",
					url: "/Employee",
				},
				{
					title: "Thêm nhân viên mới",
					url: "/Employee/Create",
				},
			],
		},
		{
			title: "Khách hàng",
			icon: "fa-light fa-user-gear",
			children: [
				{
					title: "Danh sách khách hàng",
					url: "/Company",
				},
				{
					title: "Thêm khách hàng mới",
					url: "/Company/Create",
				},
			],
		},
		{
			title: "Leads",
			icon: "fa-light fa-user-group-crown",
			children: [
				{
					title: "Danh sách Lead",
					url: "/Lead",
				},
				{
					title: "Thêm Leads",
					url: "/Lead/Create",
				},
			],
		},
		{
			icon: "fa-light fa-file-signature",
			title: "Quản lý Hợp đồng",
			children: [
				{
					title: "Danh sách Hợp đồng",
					url: "/Contract",
				},
				{
					title: "Thêm mới Hợp đồng",
					url: "/Contract/Create",
				},
			],
		},
		{
			title: "Quản lý Project",
			icon: "fa-light fa-rectangle-history",
			children: [
				{
					title: "Danh sách Project",
					url: "/Project",
				},
				{
					title: "Tạo mới Project",
					url: "/Project/Create",
				},
			],
		},
		{
			icon: "fa-light fa-square-poll-vertical",
			title: "Kế hoạch thu",
			url: "revenue-plan",
		},
		{
			icon: "fa-light fa-file-lines",
			title: "Làm hồ sơ",
			children: [
				{
					title: "Danh sách hồ sơ",
					url: "/Document",
				},
				{
					title: "Tạo mới Hồ sơ",
					url: "/Document/Create",
				},
			],
		},
	],
	dataDepearmentList: [
		{
			id: 1,
			nameDepartment: "BOD",
			codeDepartment: 25,
		},
		{
			id: 2,
			nameDepartment: "Phòng thiết kế",
			codeDepartment: 25,
		},
		{
			id: 3,
			nameDepartment: "Phòng kỹ thuật",
			codeDepartment: 25,
		},
		{
			id: 4,
			nameDepartment: "Phòng Account",
			codeDepartment: "Account",
		},
	],
	dataPositionList: [
		{
			id: 1,
			namePosition: "Account Manager",
			codePosition: "AM",
			activePosition: true,
			numberPosition: 0,
		},
		{
			id: 2,
			namePosition: "Account",
			codePosition: "AC",
			activePosition: true,
			numberPosition: 0,
		},
		{
			id: 3,
			namePosition: "Front End",
			codePosition: "FE",
			activePosition: true,
			numberPosition: 0,
		},
	],
	dataEmployeeList: [
		{
			id: 1,
			Name: "Lê Quang Nguyên",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: 2,
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
			Username: "quangnguyen1607",
			Password: "169729",
			Email: "lequangnguyen409@gmail.com",
			Province: "Hồ Chí Minh",
			Ethnic: "Kinh",
			IdentityCard: "266071249",
			IdentityCardDate: "12/04/2000",
			IdentityCardProvince: "Hồ chí minh",
			MaritalStatus: "Đã kết hôn",
			HouseholdProvince: "Hồ chí minh",
			HouseholdDistrict: "Hồ chí minh",
			HouseholdAddress: "Hồ chí minh",
			TemporaryProvince: "Hồ chí minh",
			TemporaryDistrict: "Hồ chí minh",
			TemporaryAddress: "Hồ chí minh",
			SocialInsuranceNumber: "Hồ chí minh",
			TaxCode: "0807655786",
			Department: "Phòng kỹ thuật",
			Position: "Project Manager",
			TransportName: "Vietcombank",
			TransportNumber: "1233443",
			BankBranchName: "Ho Chi Minh",
			BankName: "Vietcombank",
			BankNumber: "1012996067",
			StartDayWork: "12/07/2000",
			storeEducationInfo: [
				{
					Id: 1,
					NameSchool: "FPT polytechnic",
					Certificate: "Danh hiệu xuất xắc",
					Specialized: "Front-End Developer",
				},
				{
					Id: 2,
					NameSchool: "FPT polytechnic",
					Certificate: "Danh hiệu xuất xắc",
					Specialized: "Front-End Developer",
				},
				{
					Id: 3,
					NameSchool: "FPT polytechnic",
					Certificate: "Danh hiệu xuất xắc",
					Specialized: "Front-End Developer",
				},
			],
			contactInfomation: [
				{
					Id: 1,
					NameContact: "Lê quang nguyên",
					PhoneContact: "0706354104",
					RelationshopContact: "Gia đình",
				},
				{
					Id: 2,
					NameContact: "Lê quang nguyên",
					PhoneContact: "0706354104",
					RelationshopContact: "Gia đình",
				},
			],
		},
		{
			id: 2,
			Name: "Lê Quang Nguyên 2",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 3,
			Name: "Lê Quang Nguyên 3",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 4,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 5,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 6,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 7,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 8,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 9,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 10,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
		{
			id: 11,
			Name: "Lê Quang Nguyên 4",
			DepartmentName: "Front End",
			PositionName: "Front End",
			Gender: "Nam",
			PhoneNumber: "0808787878",
			DateOfBirth: "12/03/2000",
			ProvinceName: "HoChiMinh",
			WorkStartOn: "12/03/2020",
		},
	],
	country: [
		"Hà nội",
		"Hồ chí minh",
		"Vũng tàu",
		"Buôn mê thuộc",
		"Nha trang",
		"Phú yên",
	],
	MaritalStatus: ["Độc thân", "Đã kết hôn"],
	Department: ["Bod", "Phòng thiết kê", "Phòng kỹ thuật"],
	Position: ["Account Manager", "Project Manager", "Backend Developer"],
	Level: ["Thấp", "Trung", "Cao"],
	Account: ["Quang Nguyên", "Thanh Lâm", "Thành"],
	dataCompanyList: [
		{
			id: 1,
			NameCompany: "Đất Xanh EC 1",
			PhoneCompany: "0706354042",
			ContactCompany: "Lương Ngọc Minh Thư",
			FieldWebCompany: "Business 1",
			PriceBaseCompany: "280000000",
			Account: "Phan Thọ",
			Status: "Trạng thái",
			Name: "Đất Xanh EC 1",
			listLeadProject: [
				{
					id: 1,
					NameCompanyLead: "Đất xanh 1",
					ContractLead: "WEB-DXGROUP-032020",
					ProjectLead: "Website Đất Xanh Group",
				},
				{
					id: 2,
					NameCompanyLead: "Đất xanh 2",
					ContractLead: "WEB-DXGROUP-032020",
					ProjectLead: "Website Đất Xanh Group",
				},
				{
					id: 3,
					NameCompanyLead: "Đất xanh 3",
					ContractLead: "WEB-DXGROUP-032020",
					ProjectLead: "Website Đất Xanh Group",
				},
			],
		},
		{
			id: 2,
			NameCompany: "Đất Xanh EC 2",
			PhoneCompany: "0706354042",
			ContactCompany: "Lương Ngọc Minh Thư",
			FieldWebCompany: "Business 1",
			PriceBaseCompany: "280000000",
			Account: "Phan Thọ",
			Status: "Trạng thái",
		},
		{
			id: 3,
			NameCompany: "Đất Xanh EC 3",
			PhoneCompany: "0706354042",
			ContactCompany: "Lương Ngọc Minh Thư",
			FieldWebCompany: "Business 1",
			PriceBaseCompany: "280000000",
			Account: "Phan Thọ",
			Status: "Trạng thái",
		},
		{
			id: 4,
			NameCompany: "Đất Xanh EC 4",
			PhoneCompany: "0706354042",
			ContactCompany: "Lương Ngọc Minh Thư",
			FieldWebCompany: "Business 1",
			PriceBaseCompany: "280000000",
			Account: "Phan Thọ",
			Status: "Trạng thái",
		},
	],
	dataActivityLog: [
		{
			id: 1,
			ActivityLogType: "Edit category",
			Username: "quangnguyen@canhcam.com",
			Content: "Chỉnh sửa trang",
			DateEdit: "12/06/2022 11:59:35 PM",
		},
		{
			id: 2,
			ActivityLogType: "Edit category",
			Username: "quangnguyen@canhcam.com",
			Content: "Chỉnh sửa trang",
			DateEdit: "12/06/2022 11:59:35 PM",
		},
		{
			id: 3,
			ActivityLogType: "Edit category",
			Username: "quangnguyen@canhcam.com",
			Content: "Chỉnh sửa trang",
			DateEdit: "12/06/2022 11:59:35 PM",
		},
		{
			id: 4,
			ActivityLogType: "Edit category",
			Username: "quangnguyen@canhcam.com",
			Content: "Chỉnh sửa trang",
			DateEdit: "12/06/2022 11:59:35 PM",
		},
	],
	listLeadProject: [
		{
			id: 1,
			NameCompanyLead: "Đất xanh",
			ContractLead: "WEB-DXGROUP-032020",
			ProjectLead: "Website Đất Xanh Group",
		},
		{
			id: 2,
			NameCompanyLead: "Joyme",
			ContractLead: "Contract",
			ProjectLead: "Website Joyme",
		},
		{
			id: 3,
			NameCompanyLead: "G7",
			ContractLead: "Contract",
			ProjectLead: "Website G7",
		},
	],
	listLead: [
		{
			id: 1,
			Name: "Công ty cánh cam",
			Phone: "0706354104",
			Contact: "Lương Ngọc Minh Thư",
			TypeLead: "Web",
			Cost: "28000000000",
			Account: "Phan Thọ",
			Note: "Không có",
			listTrackingLead: [
				{
					id: 1,
					NameTask: "Đất xanh",
					CreatedDateTask: "12/06/2022",
					ContentTask: "Nội dung task ",
				},
			],
		},
		{
			id: 2,
			Name: "Công ty cánh cam",
			Phone: "0706354104",
			Contact: "Lương Ngọc Minh Thư",
			TypeLead: "Web",
			Cost: "28000000000",
			Account: "Phan Thọ",
			Note: "Không có",
		},
	],
	listInfoEducation: [
		{
			Id: 1,
			Name: "Trường ĐH Sư Phạm Tp Hồ Chí Minh",
			Certificate: "cử nhân",
			Specialized: "Công nghệ thông tin",
		},
		{
			Id: 2,
			Name: "Trường ĐH Sư Phạm Tp Hồ Chí Minh",
			Certificate: "cử nhân",
			Specialized: "Công nghệ thông tin",
		},
		{
			Id: 3,
			Name: "Trường ĐH Sư Phạm Tp Hồ Chí Minh",
			Certificate: "cử nhân",
			Specialized: "Công nghệ thông tin",
		},
		{
			Id: 4,
			Name: "Trường ĐH Sư Phạm Tp Hồ Chí Minh",
			Certificate: "cử nhân",
			Specialized: "Công nghệ thông tin",
		},
	],
	listLeadType: [
		{
			id: 1,
			name: "Web",
		},
		{
			id: 2,
			name: "Mobile/ App",
		},
		{
			id: 3,
			name: "Seo",
		},
		{
			id: 4,
			name: "Branding",
		},
	],
	listTrackingLead: [
		{
			id: 1,
			NameTask: "Đất xanh",
			CreatedDateTask: "12/06/2022",
			ContentTask: "Nội dung task ",
		},
	],
	listContact: [
		{
			id: 1,
			CodeContact: "WEB-CLASSIA-062022",
			CustomerContact: "Khang Điền",
			AccountContact: "Thu Hiền",
			TypeContact: "Web",
			PriceContact: "2800000000",
			StatusContact: "Chờ đợt 1",
		},
		{
			id: 2,
			CodeContact: "WEB-CLASSIA-062022",
			CustomerContact: "Đất xanh",
			AccountContact: "Thu Hiền",
			TypeContact: "Web",
			PriceContact: "2800000000",
			StatusContact: "Chờ đợt 1",
		},
	],
	itemContactLead: [
		{
			id: 1,
			TitleContact: "Khang điền",
			NameContact: "Anh Trung",
			PositionContract: "Giám đốc Marketing",
			PhoneContract: "0707364104",
			EmailContract: "lequangnguyen49@gmail.com",
		},
		{
			id: 2,
			TitleContact: "Khang điền",
			NameContact: "Anh Trung",
			PositionContract: "Giám đốc Marketing",
			PhoneContract: "0707364104",
			EmailContract: "lequangnguyen49@gmail.com",
		},
	],
	listDataKanban: [
		{
			id: "droppable-1",
			name: "Đợt 1",
			tasks: [
				{
					id: "draggable-1",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
					statusRevenue: 3
				},
				{
					id: "draggable-1-0",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-1",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-2",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-3",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-4",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-5",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-2",
			name: "Đợt 2",
			tasks: [
				{
					id: "draggable-2",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-3",
			name: "Đợt 3",
			tasks: [
				{
					id: "draggable-3",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-4",
			name: "Đợt 4",
			tasks: [
				{
					id: "draggable-4",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-5",
			name: "Đợt 5",
			tasks: [
				{
					id: "draggable-5",
					name: "WEB-NC-TVN-0322",
					account: " Thu hiền",
					money: 345000000,
					pm: "Gia bảo",
					note: "Đang chờ thanh toán để lập trình",
				},
			],
		},
	],
	listDataKanbanLead: [
		{
			id: "droppable-1",
			name: "New",
			tasks: [
				{
					id: "draggable-1",
					name: "Công ty may 28 Hưng phú 1",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-2",
					name: "Công ty may 28 Hưng phú 2 ",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
				{
					id: "draggable-1-3",
					name: "Công ty may 28 Hưng phú 3",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-2",
			name: "Qualified",
			tasks: [
				{
					id: "draggable-2",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-3",
			name: "PROPOSITION",
			tasks: [
				{
					id: "draggable-3",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-4",
			name: "Won",
			tasks: [
				{
					id: "draggable-4",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
			],
		},
		{
			id: "droppable-5",
			name: "Failed",
			tasks: [
				{
					id: "draggable-5",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					money: 345000000,
					contact: "Đang chờ thanh toán để lập trình",
				},
			],
		},
	],

	listDataDelivery: [
		{
			id: 1,
			NameTask: "Tên Task",
			Implement: "Cánh cam",
			Content: "Thiết kế 2 option trang chủ",
			Manday: "4 Ngày",
			StartDay: "01/06/2022",
			EndDay: "05/06/2022",
			StartDayActual: "10/06/2022",
			EndDayActual: "06/05/2022",
		},
	],
	listDataDelivery2: [
		{
			id: 1,
			NameTask: "Thiết kế trang chủ",
			Implement: "Ngọc tuấn",
			Content: "Thiết kế 2 option trang chủ",
			Manday: "4 Ngày",
			StartDay: "01/06/2022",
			EndDay: "05/06/2022",
			PersonNote: "Đã hoàn thành",
			StatusHumanImplement: "Đã hoàn thành",
			FinalStatus: "Đã hoàn thành",
			StartDayActual: "10/06/2022",
			EndDayActual: "06/05/2022",
		},
	],
	listProjectData: [
		{
			id: 1,
			Name: "CLASSIA khang điền",
			RefContact: "Khang điền",
			Account: "Thu hiền",
			TypeProject: "Triển khai từ hợp đồng",
			InvoiceStatus: "Chờ đợt 2",
			MarkStatus: 2,
			ProjectPhase: "Design",
			ProjectStatus: 3,
			DateMeeting: "12/08/2020",
			DateIncome: "12/08/2020",
			listDataDocument: [
				{
					id: 1,
					NameDocument: "Link PPM Drive dự án",
					Link: "https://docs.google.com/spreadsheets/d/1_sYkciVsOQ3-u9QBIiBwZjhrU_DBJPdlONPCo-I7T2Q/edit#gid=103176067",
				},
				{
					id: 2,
					NameDocument: "Link PPM Dự án",
					Link: "https://docs.google.com/spreadsheets/d/1_sYkciVsOQ3-u9QBIiBwZjhrU_DBJPdlONPCo-I7T2Q/edit#gid=103176067",
				},
			],
		},
		{
			id: 2,
			Name: "Forest Bay phú quốc",
			RefContact: "Khang điền",
			Account: "Thu hiền",
			TypeProject: "Triển khai từ hợp đồng",
			InvoiceStatus: "Chờ đợt 2",
			MarkStatus: 2,
			ProjectPhase: "Design",
			ProjectStatus: "TK trang trong",
		},
		{
			id: 3,
			Name: "Forest Bay phú quốc",
			RefContact: "Khang điền",
			Account: "Thu hiền",
			TypeProject: "Triển khai từ hợp đồng",
			InvoiceStatus: "Chờ đợt 2",
			MarkStatus: 3,
			ProjectPhase: "Design",
			ProjectStatus: "TK trang trong",
		},
	],
	listDataKanbanProject: [
		{
			id: "droppable-1",
			name: "In-Contract",
			tasks: [
				{
					id: "draggable-1",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 1,
				},
				{
					id: "draggable-1-2",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
				{
					id: "draggable-1-3",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
			],
		},
		{
			id: "droppable-2",
			name: "Design",
			tasks: [
				{
					id: "draggable-2",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
			],
		},
		{
			id: "droppable-3",
			name: "Lập trình",
			tasks: [
				{
					id: "draggable-3",
					name: "Công ty may 28 Hưng phú",

					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
			],
		},
		{
			id: "droppable-4",
			name: "Push nghiệm thu",
			tasks: [
				{
					id: "draggable-4",
					name: "Công ty may 28 Hưng phú",

					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
			],
		},
		{
			id: "droppable-5",
			name: "Done",
			tasks: [
				{
					id: "draggable-5",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
			],
		},
		{
			id: "droppable-6",
			name: "Undone",
			tasks: [
				{
					id: "draggable-6",
					name: "Công ty may 28 Hưng phú",
					account: "Phan thọ",
					InvoiceStatus: "Chờ đợt 1",
					ProjectStatus: "TK Trang chủ",
					MarkStatus: 2,
				},
			],
		},
	],
	dataTrackingPlan: [
		{
			id: 1,
			Date: "20/06/2000",
			Action: "Push KH thanh toán",
			Responsible: "Phương Yén",
			Status: "Đang push KH",
		},
		{
			id: 2,
			Date: "20/06/2000",
			Action: "Push KH thanh toán",
			Responsible: "Phương Yén",
			Status: "Đang push KH",
		},
	],
	dataNotification: [
		{
			id: 1,
			date: new Date(),
			content: "Khang Điền Classia được cập nhật bởi Minh Trí",
		},
		{
			id: 2,
			date: new Date(),
			content: "Khang Điền Classia được cập nhật bởi Minh Trí",
		},
	],
	dataListBrief: [
		{
			id: 1,
			CodeContract: "WEB-CICILIA-HOTEL-0520 WEB-CICILIA-HOTEL-0520",
			DataMakeBrief: "10/06/2022",
			StatusBrief: "Mới yêu cầu làm hồ sơ",
			DateRecive: "16:15 ngày16/06/2022",
			InfomationCustomer: "Chị Hiền",
			Note: "lorem",
		},
		{
			id: 2,
			CodeContract: "WEB-CICILIA-HOTEL-0521",
			DataMakeBrief: "10/06/2022",
			StatusBrief: "Mới yêu cầu làm hồ sơ",
			DateRecive: "16:15 ngày16/06/2022",
			InfomationCustomer: "Chị Hiền",
			Note: "lorem",
		},
		{
			id: 3,
			CodeContract: "WEB-CICILIA-HOTEL-0522",
			DataMakeBrief: "10/06/2022",
			StatusBrief: "Mới yêu cầu làm hồ sơ",
			DateRecive: "16:15 ngày16/06/2022",
			InfomationCustomer: "Chị Hiền",
			Note: "lorem",
		},
		{
			id: 4,
			CodeContract: "WEB-CICILIA-HOTEL-0523",
			DataMakeBrief: "10/06/2022",
			StatusBrief: "Mới yêu cầu làm hồ sơ",
			DateRecive: "16:15 ngày16/06/2022",
			InfomationCustomer: "Chị Hiền",
			Note: "lorem",
		},
	],
};
